export const pincodefetch = async(latitude,longitude) => {
    const response = await fetch(
    `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`
  );
  // const data = await response.json();

      const data = await response.json();
      const pincode = data.address.postcode;
      console.log('pincode fetched', pincode)

      return pincode || null
}